/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, concatMap, from, map } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { Scenario } from '@scenario/models/scenario.model';
import { RootState } from '@store/create-store';
import { exportSelectedScenariosSuccess } from '@store/scenario/scenarios/export-selected-scenarios-slice';
import { UnitRate } from '@scenario/models/unit-rate.model';

export const exportSelectedScenariosEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('exportSelectedScenarios/exportSelectedScenarios'),
    concatMap((action: PayloadAction<{ scenarios: Scenario[], rawScenarios: Scenario[], unitRates: UnitRate[] }>) =>
      from(dependencies.exportGateway.exportAsXlsx(action.payload.scenarios, action.payload.rawScenarios, action.payload.unitRates)).pipe(
        map((scenarios: Scenario[]) => exportSelectedScenariosSuccess(scenarios)),
      ),
    ),
  );
